module.exports = __webpack_public_path__ + "static/img/template-img3.f5f35170.png";